import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/tokens.css';
import './App.css';
import CustomerApp from './App';
import { CustomerAuthProvider } from './contexts/CustomerAuthContext';
import { ConfirmProvider } from './components/ui/ConfirmDialog';
// anti-slop loads LAST so its rules beat per-screen CSS.
import './styles/anti-slop.css';

// Suppress console output in production (not staging/preview)
if (process.env.NODE_ENV === 'production' && !window.location.hostname.includes('staging') && !window.location.hostname.includes('vercel.app')) {
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  console.warn = noop;
  // console.error is kept active for real error visibility
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CustomerAuthProvider>
      <ConfirmProvider>
        <CustomerApp />
      </ConfirmProvider>
    </CustomerAuthProvider>
  </React.StrictMode>
);
